import React from 'react';
import GrayShadowBox from '../../GrayShadowBox';

const ProductTitle = ({ 
    product,
    editingTitleEn,
    tempTitleEn,
    onTitleEnClick,
    onTitleEnSave,
    onTitleEnCancel,
    onTempTitleEnChange
}) => {
    return (
        <GrayShadowBox>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">제품명</h2>
            <div className="space-y-2">
                {product.source_site === 'weverse' ? (
                    // 위버스는 영문만 표시
                    product.title_en && (
                        <div>
                            {editingTitleEn ? (
                                <div className="space-y-2">
                                    <input
                                        type="text"
                                        value={tempTitleEn}
                                        onChange={(e) => onTempTitleEnChange(e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="영문 제품명을 입력하세요"
                                        autoFocus
                                    />
                                    <div className="flex gap-2">
                                        <button
                                            onClick={onTitleEnSave}
                                            className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
                                        >
                                            저장
                                        </button>
                                        <button
                                            onClick={onTitleEnCancel}
                                            className="px-3 py-1 bg-gray-500 text-white text-sm rounded hover:bg-gray-600"
                                        >
                                            취소
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <p 
                                    className="text-gray-800 mt-1 cursor-pointer hover:text-blue-600 underline decoration-dotted decoration-blue-400"
                                    onClick={onTitleEnClick}
                                    title="클릭하여 편집"
                                >
                                    {product.title_en}
                                </p>
                            )}
                        </div>
                    )
                ) : (
                    // 다른 사이트는 영문/한글 모두 표시
                    <>
                        {product.title_en && (
                            <div>
                                {editingTitleEn ? (
                                    <div className="space-y-2">
                                        <input
                                            type="text"
                                            value={tempTitleEn}
                                            onChange={(e) => onTempTitleEnChange(e.target.value)}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            placeholder="영문 제품명을 입력하세요"
                                            autoFocus
                                        />
                                        <div className="flex gap-2">
                                            <button
                                                onClick={onTitleEnSave}
                                                className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
                                            >
                                                저장
                                            </button>
                                            <button
                                                onClick={onTitleEnCancel}
                                                className="px-3 py-1 bg-gray-500 text-white text-sm rounded hover:bg-gray-600"
                                            >
                                                취소
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <p 
                                        className="text-gray-800 mt-1 cursor-pointer hover:text-blue-600 underline decoration-dotted decoration-blue-400"
                                        onClick={onTitleEnClick}
                                        title="클릭하여 편집"
                                    >
                                        {product.title_en}
                                    </p>
                                )}
                            </div>
                        )}
                        {product.title && (
                            <div>
                                <p className="text-xs text-gray-600 mt-1">
                                    {product.title}
                                </p>
                            </div>
                        )}
                    </>
                )}
            </div>
        </GrayShadowBox>
    );
};

export default ProductTitle;
